import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, MessageSquareText } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/products", label: "Products" },
  { to: "/therapeutic-areas", label: "Therapeutic Areas" },
  { to: "/quality", label: "Quality" },
  { to: "/vision-2030", label: "Vision" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const linkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors duration-200 hover:text-[#1D4ED8] ${
      isActive ? "text-[#1D4ED8]" : "text-slate-600"
    }`;

  return (
    <header
      data-testid="main-navbar"
      className="sticky top-0 z-50 border-b border-slate-200/70 bg-white/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img
            src="/assets/logo-horizontal.png"
            alt="Cytocare Formulations"
            className="h-9 w-auto"
          />
        </Link>

        <nav className="hidden items-center gap-6 lg:flex" data-testid="nav-links">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkCls} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <Link
            to="/contact"
            data-testid="nav-enquire-button"
            className="inline-flex items-center gap-2 rounded-full bg-[#1D4ED8] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors duration-200 hover:bg-[#173CAE]"
          >
            <MessageSquareText size={15} /> Enquire
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="rounded-md p-2 text-slate-700 hover:bg-slate-100 lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-200 bg-white px-4 pb-6 pt-3 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2.5 text-sm font-medium ${
                    isActive ? "bg-blue-50 text-[#1D4ED8]" : "text-slate-600 hover:bg-slate-50"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-enquire-button"
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-full bg-[#1D4ED8] px-5 py-2.5 text-sm font-semibold text-white"
            >
              <MessageSquareText size={15} /> Enquire
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
